<app-image-carousel *ngIf="images?.length" [images]="images" [guestDisplay]="guestDisplay" [zoom]="zoom" (handleZoom)="handleZoom($event)">
</app-image-carousel>
